import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Pin = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 25 25' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M12.5 15.343h-7v-1.735c0-.49.194-.96.54-1.305A6.7 6.7 0 0 0 8 7.573v-2.23a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v2.23a6.7 6.7 0 0 0 1.959 4.73c.346.346.54.815.54 1.305v1.735zm0 0v6'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M10.241 3.343c-1.372 0-2.484 1.137-2.484 2.539v2.057a5.55 5.55 0 0 1-1.571 3.877 2.42 2.42 0 0 0-.687 1.694v1.603c0 .382.304.692.678.692h5.645v4.846c0 .382.303.692.677.692s.678-.31.678-.692v-4.846h5.645c.374 0 .677-.31.677-.692V13.51c0-.635-.247-1.244-.686-1.694A5.55 5.55 0 0 1 17.24 7.94V5.882c0-1.402-1.112-2.539-2.484-2.539z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
